import { useEffect } from "react";
import { scrollToTop } from "../libraries/ercLibrary";

export default function useScrollRestorationEcommerce(location, isMounted) {
  useEffect(() => {
    /* In order code to work correctly component must mount. 
    When l write this code, l figured out on console that null valuse also indicated component did mount.
    l didnt quite understand but this is the situation. */
    if (isMounted === null || isMounted === true) {
      const height = sessionStorage.getItem(location);

      // This gives us the whole scrollable height (Not only the visible height)
      const fullScrollHeight = Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.offsetHeight,
        document.body.clientHeight,
        document.documentElement.clientHeight
      );

      /* l compare the height stored in session storage with the scrollable height. 
      While page is loading scrollable height is low and storage height is high. So it wouldnt
      work correctly. Therefore, code must only run after page load which we figure out by cheking the height is greater. */
      if (height && height > fullScrollHeight) {
        scrollToTop();
      } else if (height) {
        scrollToTop(height);
      } else {
        scrollToTop();
      }
    }
  }, [location, isMounted]);
}
